import axios from "axios";
import { ADMIN_URL } from "../utils/constants";

const LOGS = "ADMIN_LOGS";

/**
 * @param {string} code
 * @param {string} message
 * @param {Record<string, any> | string[] | string | undefined} data
 */
export async function sendAdminLog(code, message, data, isRepeat = false) {
  if (!ADMIN_URL) {
    return;
  }

  const logBody = {
    message,
    code,
    data,
  };

  try {
    await axios.post(`${ADMIN_URL}/logger`, logBody);
  } catch (e) {
    if (isRepeat) {
      throw e;
    }
    addNotSendLog(logBody);
  }
}

function addNotSendLog(log) {
  const logs = getNotSendLogs();
  localStorage.setItem(LOGS, JSON.stringify([...logs, log]));
}

/**
 * @returns {Record<string, any>[]}
 */
function getNotSendLogs() {
  const logsForSend = localStorage.getItem(LOGS);
  if (logsForSend) {
    try {
      return JSON.parse(logsForSend) || [];
    } catch {
      localStorage.removeItem(LOGS);
    }
  }

  return [];
}

export async function sendErrorsLogs() {
  const parsedLogs = getNotSendLogs();
  if (parsedLogs.length) {
    try {
      const { data } = await axios.post(`${ADMIN_URL}/logger/many`, {
        logs: parsedLogs,
      });
      if (data.length) {
        const notSavedLogs = parsedLogs.filter(
          (log) =>
            !data.some(
              (successLog) =>
                successLog.code === log.code &&
                successLog.message === log.message,
            ),
        );
        if (notSavedLogs.length) {
          localStorage.setItem(LOGS, JSON.stringify(notSavedLogs));
        } else {
          localStorage.removeItem(LOGS);
        }
      }
    } catch {
      localStorage.removeItem(LOGS);
    }
  }
}

/**
 * @param {string} message
 */
export function logNotFoundTrackInfo(message) {
  return sendAdminLog("E001", message);
}

/**
 * @param {string} errText
 * @param {{
 *   radioType: 'rock' | 'mc' | 'lite';
 *   trackName: string;
 * }} data
 */
export function logPlayingStreamError(errText, data) {
  return sendAdminLog("E002", errText, data);
}

/**
 * @param {string} trackId
 * @param {string[]} data
 */
export function logEmptySomeTrackInfo(trackId, data) {
  return sendAdminLog("E003", trackId, data);
}

/**
 * @param {string} errText
 */
export function logAppError(errText) {
  return sendAdminLog("E004", errText);
}

/**
 * @param {string} errText
 * @param {string} url
 * @param {string} status
 * @param {Record<string, any>} body
 */
export function log400BackError(errText, url, status, body) {
  return sendAdminLog("E400", errText, { url, status, body });
}

/**
 * @param {string} errText
 * @param {string} url
 * @param {string} status
 * @param {Record<string, any>} body
 */
export function log500BackError(errText, url, status, body) {
  return sendAdminLog("E500", errText, { url, status, body });
}

export function handleAxiosCatchResponse(e, url = "") {
  const status = e?.response?.status || 0;
  if (status >= 400) {
    const logArgs = [e.message, e.response?.config.url || url, status];
    if (status >= 500) {
      log500BackError(...logArgs);
    } else if (status >= 400) {
      log400BackError(...logArgs);
    }
  }
}

/**
 * @param {import('@apollo/client/link/error').ErrorResponse} errorLink
 */
export function handleApolloCatchResponse(errorLink) {
  const { networkError } = errorLink;
  if (networkError) {
    const status = networkError.statusCode;
    const logArgs = [
      networkError.message,
      networkError.response?.url ?? "",
      status,
      {
        request: {
          query: errorLink.operation.query.loc?.source.body,
          variables: errorLink.operation.variables,
        },
        response: errorLink.networkError.result,
      },
    ];

    if (status >= 500) {
      log500BackError(...logArgs);
    } else if (status >= 400) {
      log400BackError(...logArgs);
    }
  }
}

// TODO: Добавить обработчики ошибок с бэка на все запросы
